import React from 'react';
import { Navigate } from 'react-router-dom';
import { useAuth } from '../context/AuthContext';

const RoleBasedRedirect = () => {
  const { user, isSystemAdmin } = useAuth();

  // Sistem Admin kullanıcısı admin paneline yönlendir
  if (isSystemAdmin()) {
    return <Navigate to="/admin" replace />;
  }

  // İşletme sahipleri (patron) owner dashboard'a yönlendir
  if (user?.isOwner || user?.user_type === 'patron') {
    return <Navigate to="/owner" replace />;
  }

  // Personel dashboard'a yönlendir
  return <Navigate to="/dashboard" replace />;
};

export default RoleBasedRedirect;